<template lang="jade">
  template(v-if="fdata.media === 'print'")
    include ../_partials/pdf.jade
  template(v-else)
    template(v-if="fdata.openAs === 'newWindow'")
      include ../_partials/link.jade
    template(v-else)  
      include ../_partials/button.jade
</template>
<script>
  import buttons from '../_shared/traits'
  // import { Workflows } from 'src/services/resources'
  import {addDynamicWorkflow,
          addNotification,
          addWorkflow} from 'src/vuex/actions'
  import api from 'src/config/api'

  const queryString = params => {
    return Object.entries(params)
                  .map(paramString)
                  .join('&')
  }

  const paramString = pair => {
    let [k, v] = pair
    switch (Object.prototype.toString.call(v)) {
      case '[object Object]':
        return objParamString(k, v)
      case '[object Array]':
        return `${k}[]=${v[0]}`
      default:
        return `${k}=${v}`
    }
  }

  const objParamString = (prop, params) => {
    return Object.entries(params).map(xs => `${prop}[${xs[0]}]=${xs[1]}`).join('&')
  }

  export default {
    data: () => ({}),
    mixins: [buttons],
    vuex: {
      actions: {
        dynamicWorkflow: addDynamicWorkflow,
        notice: addNotification,
        addWorkflow
      }
    },
    filters: {
      newWindow (data) {
        return location.origin + location.pathname + `?nw=${data.buttonId}`
      },
      pdf (data) {
        let params = _.pick(data, ['siteId', 'workflowId', 'dbWorkflowKey', 'workflowParameters', 'actions', 'openAs'])
        let render = _.template('<%= origin %><%= pathname %>?<%= params %>')
        let url = render({origin: api.http.root,
                          pathname: api.endpoints.data.pdf,
                          params: queryString(params) })
        return encodeURI(url)
      }
    },
    methods: {
      click (action) {
        if (this.fdata.openAs === 'modal') {
          this.dialog()
        } else {
          this.$dispatch('replace::workflow',
                        this.fdata.workflowId,
                        this.uid,
                        {button: this.fdata.buttonId})
        }
      },
      dialog () {
        this.dynamicWorkflow({
          wid: this.fdata.workflowId,
          fkey: this.uid,
          params: { workflowParameters: this.fdata.workflowParameters,
                    dbWorkflowKey: this.fdata.dbWorkflowKey },
          sid: this.fdata.siteId,
          headers: this.headers,
          button: this.fdata
        })
      }
    },
    ready () {
      localStorage.setItem('new::window' + this.fdata.buttonId, JSON.stringify({
        wid: this.fdata.workflowId,
        params: {button: this.fdata.buttonId},
        headers: this.headers
      }))
    }
  }
</script>



// WEBPACK FOOTER //
// newWorkflow.vue?0265630c